import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';

const useCurrentUser = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [currentUser, setCurrentUser] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    updateUserDetails();
    
    // Listen for user-logged-in event to update state immediately
    const handleUserLoggedIn = () => {
      // Small delay to ensure localStorage is updated
      setTimeout(() => {
        updateUserDetails();
      }, 100);
    };
    
    window.addEventListener('user-logged-in', handleUserLoggedIn);
    
    return () => {
      window.removeEventListener('user-logged-in', handleUserLoggedIn);
    };
  }, []);

  const updateUserDetails = () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    if (userDetails && userDetails.data?.customer?.id) {
      setIsLoggedIn(true);
      setLoggedInUser(userDetails.data?.customer.id);
      setCurrentUser(userDetails);
    } else {
      setIsLoggedIn(false);
      setLoggedInUser(null);
      setCurrentUser({});
    }
  };

  const loginUser = (userData) => {
    localStorage.setItem("userDetails", JSON.stringify(userData));
    updateUserDetails();
  };

  const logoutUser = () => {
    localStorage.removeItem("userDetails");
    setIsLoggedIn(false);
    setLoggedInUser(null);
    setCurrentUser({});
    navigate("/");
  };

  return {
    isLoggedIn,
    loggedInUser,
    currentUser,
    loginUser,
    logoutUser,
  };
};

export default useCurrentUser;
